import { PayloadAction, createSlice } from "@reduxjs/toolkit";

import { ICustomer } from "@defs/customer";

interface CustomersState {
  list: {
    data: ICustomer[];
    loading: boolean;
    error: boolean;
  };
  openedTickets: {
    count: number;
    loading: boolean;
  };
}

const initialState: CustomersState = {
  list: {
    data: [],
    loading: false,
    error: false,
  },
  openedTickets: {
    count: null,
    loading: false,
  },
};

const customersSlice = createSlice({
  name: "customers",
  initialState,
  reducers: {
    resetCustomers(state) {
      state.list.data = [];
    },
  },
  extraReducers: {
    "customers/list/pending": (state) => {
      state.list.loading = true;
      state.list.data = [];
    },

    "customers/list/fulfilled": (state, action: PayloadAction<ICustomer[]>) => {
      state.list.loading = false;
      state.list.data = action.payload;
    },

    "customers/tickets-opened/pending": (state) => {
      state.openedTickets.loading = true;
      state.openedTickets.count = null;
    },

    "customers/tickets-opened/fulfilled": (
      state,
      action: PayloadAction<number>
    ) => {
      state.openedTickets.loading = false;
      state.openedTickets.count = action.payload;
    },
  },
});

export const customersActions = customersSlice.actions;

export default customersSlice.reducer;
